export const setUserType = ( string ) => {
  return{
    type: 'SET_USER_TYPE',
    payload: string
  }
}